module.exports = __webpack_public_path__ + "static/media/init-slide-4.ae323690.png";